import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { usePesInitContext } from "contexts/purhaseExpenseSyncPage/pesInitContext";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getActionPesDisplay } from "utils/HelperPesFunction";
export default function PesFooterSubmit(param) {
    var setFieldValue = param.setFieldValue, setModalConfirmCancel = param.setModalConfirmCancel, values = param.values, formdisabled = param.formdisabled;
    var navigate = useNavigate();
    var productRow = usePesInitContext().productRow;
    var _useState = _sliced_to_array(useState(getActionPesDisplay({
        formdisabled: formdisabled,
        dimMstNewStatus: values.dimMstReceiptStatus,
        values: values
    })), 2), displaySubmitBtn = _useState[0], setDisplaySubmitBtn = _useState[1];
    useEffect(function() {
        setDisplaySubmitBtn(getActionPesDisplay({
            formdisabled: formdisabled,
            dimMstNewStatus: values.dimMstPesStatus,
            values: values
        }));
    }, [
        values.dimMstPesStatus,
        formdisabled
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "card pagezoom card-st-3  mb-4 fixed bottom-0 w-[calc(100%-110px)] drop-shadow z-[10]",
        style: {
            minWidth: "1000px"
        },
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card-body px-xl-3 d-flex justify-between",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "flex gap-2"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex gap-3",
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            onClick: function() {
                                navigate("/financial-accounting/peak-connection/pes");
                            },
                            className: "btn-st-6 btn ms-auto",
                            children: "ย้อนกลับ"
                        }),
                        displaySubmitBtn.canDraftStatus && /*#__PURE__*/ _jsx(Button, {
                            type: "submit",
                            onClick: function() {
                                setFieldValue("dim_mst_pes_status_id", 1);
                            },
                            className: "btn btn-st-3",
                            children: "บันทึกร่าง"
                        }),
                        displaySubmitBtn.canCancelStatus && /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            onClick: function() {
                                setModalConfirmCancel(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true
                                    });
                                });
                            },
                            className: "bg-[#ff0000] text-white border-[#ff0000] me-3 btn",
                            children: "ยกเลิก"
                        }),
                        displaySubmitBtn.canDraftStatus && /*#__PURE__*/ _jsx(Button, {
                            type: "submit",
                            onClick: function() {
                                setFieldValue("dim_mst_pes_status_id", 2);
                            },
                            className: "btn btn-st-10",
                            disabled: productRow.filter(function(v) {
                                return v.docNumber;
                            }).length === 0,
                            children: "ส่งออก"
                        }),
                        displaySubmitBtn.canRetrySyncStatus && /*#__PURE__*/ _jsx(Button, {
                            type: "submit",
                            onClick: function() {
                                setFieldValue("dim_mst_pes_status_id", 2);
                            },
                            className: "btn btn-st-10",
                            children: "ส่งออกอีกครั้ง"
                        })
                    ]
                })
            ]
        })
    });
}
